import { FALLBACK_BOOTSTRAP } from "./data";
import type { InquiryPayload, MonthPrice, OwnerDashboardData, PublicBootstrap } from "./types";

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", ...init?.headers },
    ...init,
  });

  const body = (await response.json().catch(() => ({}))) as { error?: string } & T;
  if (!response.ok) throw new Error(body.error || "Something went wrong. Please try again.");
  return body;
}

export async function getPublicBootstrap(): Promise<PublicBootstrap> {
  try {
    return await request<PublicBootstrap>("/api/public/bootstrap");
  } catch {
    return FALLBACK_BOOTSTRAP;
  }
}

export function createInquiry(payload: InquiryPayload) {
  return request<{ id: string; status: "pending"; quotedPrice: number }>("/api/inquiries", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function ownerLogin(password: string) {
  return request<{ ok: true }>("/api/admin/login", {
    method: "POST",
    body: JSON.stringify({ password }),
  });
}

export function ownerLogout() {
  return request<{ ok: true }>("/api/admin/logout", { method: "POST", body: "{}" });
}

export function getOwnerDashboard() {
  return request<OwnerDashboardData>("/api/admin/dashboard");
}

export function updateBooking(id: string, status: "approved" | "rejected", ownerNote?: string) {
  return request<{ ok: true }>(`/api/admin/bookings/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ status, ownerNote }),
  });
}

export function createBlock(payload: { startDate: string; endDate: string; label: string }) {
  return request<{ id: string }>("/api/admin/blocks", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function deleteBlock(id: string) {
  return request<{ ok: true }>(`/api/admin/blocks/${id}`, { method: "DELETE" });
}

export function savePrices(prices: MonthPrice[]) {
  return request<{ ok: true }>("/api/admin/prices", {
    method: "PUT",
    body: JSON.stringify({ prices }),
  });
}
